/*eslint no-script-url: 0 */
import React, { Component } from "react";
import MatSizeSelection from '../Components/Mats/MatSizeSelection';
import MatSelection from '../Components/Mats/MatSelection';
import {Loader} from '../Helpers/Helpers';
import Constants from '../Config/Config';

const URL = Constants.URL.root+'/wp-content/themes/justpictureframing/data/mats.json';

class Mats extends Component {

	constructor(props) {
        super(props);
        this.state = {
            error: null,
            runAPI: false
        }
    }

    fetchMats = () => {
        var self = this;
        this.setState({ runAPI: true });
        fetch(URL)
        .then(response => {
            if (!response.ok) {
                throw Error('Network request failed.')
            }
            return response;
        })
        .then(data => data.json())
        .then(data => {
            //console.log(data);
            self.dispatchMatsData(data);
        }, (ex) => {
            self.setState({ error: ex.message });
        })
    }

    dispatchMatsData(MatsData) {
        const data = MatsData;
        this.props.dispatch({
            type: 'SET_STATE',
            state: {
                mats: data,
                matsLoaded: true
            }
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (('mats' === this.props.selectedTab && !this.state.runAPI) || prevProps.showMeHow !== this.props.showMeHow) {
            this.fetchMats();
        }
    }

	render() {
	    return (
			<div className="row">
				<div className="col-sm-12 mats-items">
					<div className="card h-100">
						<div className="card-body">
							{this.props.matsLoaded === true ?
								<div className="row">
									<MatSizeSelection
										{...this.props} />
									<MatSelection
										{...this.props}
										error={this.state.error} />
								</div> :
								<Loader/>
							}
						</div>
					</div>
				</div>
			</div>
	    );
  	}
}

export default Mats;